import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
} from "@chakra-ui/react"
import { type FC, type ReactNode } from "react"

type GenericModalProps = {
  children?: ReactNode // ModalBody content
  isOpen: boolean
  onClose: () => void
  title?: string
  footer?: ReactNode // ModalFooter content
  maxWidth?: string
  height?: any
  top?: any
  mt?: any
  mx?: any
}

const GenericModal: FC<GenericModalProps> = ({
  children,
  isOpen,
  onClose,
  title,
  footer,
  maxWidth,
  height,
  top,
  mt,
  mx,
}) => {
  return (
    <Modal closeOnOverlayClick isOpen={isOpen} onClose={onClose}>
      <ModalOverlay backdropFilter="blur(5px)" />
      <ModalContent
        height={height ? height : { base: "100%", md: "auto" }}
        maxWidth={{ base: "100%", md: maxWidth ? maxWidth : "960px" }}
        mb={{ base: 4, sm: 6, md: 8 }}
        mt={mt ? mt : { sm: "0px" }}
        mx={mx ? mx : { base: "0px", md: "auto" }}
        top={top ? top : { base: "0px", md: "120px" }}
      >
        {title ? (
          <ModalHeader
            borderBottomColor="gray.100"
            borderBottomWidth={1}
            p={4}
            textStyle="h5"
          >
            {title}
          </ModalHeader>
        ) : null}

        <ModalCloseButton />

        <ModalBody overflowY="auto" px={4} py={4}>
          {children}
        </ModalBody>

        {footer ? (
          <ModalFooter justifyContent="flex-start" p={4}>
            {footer}
          </ModalFooter>
        ) : null}
      </ModalContent>
    </Modal>
  )
}

export default GenericModal
